class CouldNotCreateStepProcessor extends Error {}

export default CouldNotCreateStepProcessor;
